import React from 'react';

import {
  useWishlistButtonHelper,
  UseWishlistButtonHelperProps,
  UseWishlistButtonHelperResult,
} from './useWishlistButtonHelper';

export interface WishlistButtonHelperProps extends UseWishlistButtonHelperProps {
  children(props: UseWishlistButtonHelperResult): React.ReactNode;
}

export const WishlistButtonHelper = ({ children, product, sku }: WishlistButtonHelperProps) => {
  const useWishlistButtonHelperResult = useWishlistButtonHelper({ product, sku });

  return (
    <>
      {children(useWishlistButtonHelperResult)}
      {/* Live region sempre presente nel DOM: gli screen reader annunciano il feedback solo se il nodo esiste prima dell'aggiornamento. */}
      <span aria-live="polite" className="visually-hidden" role="status">
        {useWishlistButtonHelperResult.feedback}
      </span>
    </>
  );
};
